export const WHATSAPP_NUMBER = '5493513830202'

const FALLBACK_MESSAGE = [
  'Hola Gaby 🌿',
  '',
  'Acabo de completar el Skin Fresh Index™ y me gustaría recibir mi diagnóstico completo, mi rutina personalizada y la guía gratuita.',
].join('\n')

const detailedMessage = (skinType: string, score: number): string =>
  [
    'Hola Gaby 🌿',
    '',
    'Acabo de completar el Skin Fresh Index™ y me gustaría recibir:',
    '',
    '✨ Mi diagnóstico completo',
    '🧴 Mi rutina personalizada',
    '📖 La guía gratuita "Los 7 errores que hacen que una crema no funcione (aunque sea cara)"',
    '',
    'Mi resultado fue:',
    '',
    `• Tipo de piel: ${skinType}`,
    `• Skin Fresh Index™: ${score}/100`,
  ].join('\n')

export const whatsappUrl = (skinType?: string, score?: number): string => {
  const hasVariables =
    Boolean(skinType) && skinType !== 'Sin definir' && typeof score === 'number'

  const text = hasVariables
    ? detailedMessage(skinType as string, score as number)
    : FALLBACK_MESSAGE

  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`
}
